module.exports = __webpack_public_path__ + "static/media/6-rectangle-occupied.1d8a7c59.svg";